import {connect} from "react-redux";
import CalendarBusy from "./CalendarBusy";
import {compose} from "redux";
import {WithAppendHeaderAndFooterHOC} from "../../HOC/WithAppendHeaderAndFooterHOC";
import {WithAppendSidebarHOC} from "../../HOC/WithAppendSidebarHOC";
import {
    changeObject,
    changeRoom,
    getAvailabilityObjectsList,
    getAvailabilityTable,
    getRoomsListForAvailibility,
    removeAvailability,
    updateAvailability
} from "./actions";
import {getObjectsList, searchObjects} from "../Objects/actions";
import {
    getAvailabilitiesIdSelector,
    getAvailibilityObjectsSelector,
    getDatesAllSelector,
    getDatesSelector,
    getRoomIdSelector,
    getRoomNameBusySelector,
    getRoomsListSelector
} from "./selectors";
import {WithModeratorSearchHOC} from "../../HOC/WithModeratorSearchHOC";
import {getChannelManagerLinkSelector} from "../CalendarPercent/selectors";
import {WithSavingSnackBar} from "../../HOC/WithSavingSnackBar";


let mapStateToProps = (state) => {
    return {
        objectsAvailability: getAvailibilityObjectsSelector(state),
        roomsList: getRoomsListSelector(state),
        datesAll: getDatesAllSelector(state),
        dates: getDatesSelector(state),
        roomId: getRoomIdSelector(state),
        availabilitiesId: getAvailabilitiesIdSelector(state),
        channelManagerLink: getChannelManagerLinkSelector(state),
        roomName: getRoomNameBusySelector(state),
    }
};

export default compose(connect(mapStateToProps, {
    getAvailabilityTable,
    getObjectsList,
    getRoomsListForAvailibility,
    updateAvailability,
    removeAvailability,
    getAvailabilityObjectsList,
    searchObjects,
    changeRoom,
    changeObject

}), WithAppendHeaderAndFooterHOC, WithAppendSidebarHOC, WithModeratorSearchHOC, WithSavingSnackBar)(CalendarBusy);



